import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { NAV, PHONE_TEL, TRAININGS, serviceHref } from "@/lib/site";

const linkCls = ({ isActive }) =>
  `text-[13px] font-semibold uppercase tracking-[0.14em] transition-colors hover:text-white ${isActive ? "text-white" : "text-neutral-400"}`;

const ServicesMenu = () => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger data-testid="nav-egitimler" className="flex items-center gap-1 text-[13px] font-semibold uppercase tracking-[0.14em] text-neutral-400 outline-none transition-colors hover:text-white data-[state=open]:text-white">
      Eğitimler <ChevronDown className="h-3.5 w-3.5" />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" sideOffset={14} className="w-64 rounded-none border-white/10 bg-black/95 p-2 text-white backdrop-blur-xl">
      {TRAININGS.map((s) => (
        <DropdownMenuItem key={s.key} asChild className="rounded-none px-3 py-2.5 focus:bg-brand focus:text-white">
          <Link to={serviceHref(s.key)} data-testid={`nav-service-${s.key}`} className="font-display text-xl tracking-wide">{s.title}</Link>
        </DropdownMenuItem>
      ))}
      <DropdownMenuSeparator className="bg-white/10" />
      <DropdownMenuItem asChild className="rounded-none px-3 py-2.5 text-xs uppercase tracking-[0.15em] text-neutral-400 focus:bg-white/10 focus:text-white">
        <Link to="/egitimlerimiz" data-testid="nav-service-all">Tüm eğitimler</Link>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

const MobileMenu = ({ close }) => (
  <nav data-testid="mobile-menu" className="max-h-[calc(100svh-4rem)] overflow-y-auto border-t border-white/10 bg-black px-5 py-4 xl:hidden">
    {NAV.map((n) => (
      <div key={n.to}>
        <Link to={n.to} onClick={close} data-testid={`mobile-nav-${n.to.slice(1) || "home"}`} className="block border-b border-white/5 py-3 font-display text-2xl tracking-wide text-white">{n.label}</Link>
        {n.children && (
          <div className="grid grid-cols-2 gap-x-4 border-b border-white/5 py-2 pl-3">
            {TRAININGS.map((s) => (
              <Link key={s.key} to={serviceHref(s.key)} onClick={close} data-testid={`mobile-nav-service-${s.key}`} className="py-2 text-sm text-neutral-400">{s.title}</Link>
            ))}
          </div>
        )}
      </div>
    ))}
    <a href={PHONE_TEL} data-testid="mobile-call-btn" className="mt-4 flex items-center justify-center gap-2 border border-white/20 py-3 font-semibold text-white"><Phone className="h-4 w-4" /> 0539 260 83 20</a>
  </nav>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 md:h-20 md:px-8">
        <Link to="/" data-testid="header-logo-link" aria-label="FX Motor Sporları ana sayfa" className="shrink-0">
          <span className="logo-shine" style={{ "--logo-mask": "url(/fx-logo-dark.png)" }} data-testid="header-logo"><img src="/fx-logo-dark.png" alt="FX Motors logosu" className="h-5 w-auto sm:h-6 md:h-7" /></span>
        </Link>
        <nav className="hidden items-center gap-6 xl:flex">
          {NAV.map((n) => n.children ? <ServicesMenu key={n.to} /> : (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-${n.to.slice(1) || "home"}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={PHONE_TEL} data-testid="header-call-btn" className="hidden items-center gap-2 border border-white/20 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:border-white sm:flex">
            <Phone className="h-4 w-4" /> Ara
          </a>
          <Link to="/rezervasyon" data-testid="header-booking-btn" className="bg-brand px-3 py-2 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-brand sm:px-4 sm:py-2.5 sm:text-sm">
            Rezervasyon
          </Link>
          <button data-testid="mobile-menu-toggle" aria-label="Menü" onClick={() => setOpen(!open)} className="p-2 text-white xl:hidden">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && <MobileMenu close={() => setOpen(false)} />}
    </header>
  );
};
